import { createBrowserHistory } from 'history';

import { initNavigationDepth, recordNavigation } from './navigationDepth';

export const history = createBrowserHistory({
  basename: process.env.REACT_APP_ROUTER_BASENAME,
});

initNavigationDepth(history.location.key);

history.listen((location, action) => recordNavigation(action, location));
